// extracted by mini-css-extract-plugin
export default {"container":"ServiceData_container__Zh2nJ","block":"ServiceData_block__mhjMG"};